import { render, staticRenderFns } from "./SodexoReports.vue?vue&type=template&id=2d62d295&scoped=true&"
import script from "./SodexoReports.vue?vue&type=script&lang=js&"
export * from "./SodexoReports.vue?vue&type=script&lang=js&"
import style0 from "./SodexoReports.vue?vue&type=style&index=0&id=2d62d295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62d295",
  null
  
)

export default component.exports